<template>
    <div class="row mb-3">
        <div class="col text-right noPadding">
            <el-input
                type="search"
                class=""
                clearable
                prefix-icon="el-icon-search"
                style="width: 250px"
                placeholder="Suche"
                v-model="searchLicenses"
                aria-controls="datatables"
            >
            </el-input>
        </div>
    </div>
    <div class="row">
        <modal v-model:show="userModal" modal-classes="modal-lg">
            <template v-slot:header>
                <h4 class="modal-title">Benutzer ({{ month }})</h4>
            </template>
            <div>
                <LicenseUsersTable :userLicenses="userLicensesData" :searchUser="searchUser"></LicenseUsersTable>
            </div>
        </modal>
        <el-table @row-click="getLicenseUser"
                  type="index"
                  class="table-responsive clickableRow"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                  :default-sort="{ prop: 'readable_license_label', order: 'ascending' }"
                  empty-text="Keine Einträge vorhanden"
                  @sort-change="changeSort"
                  :data="filteredLicenses">
            <el-table-column prop="readable_license_label" label="Softwarelizenz" min-width="170px"
                             sortable="custom"
                             :sort-orders="['ascending', 'descending']">
                <template v-slot="{ row }">
                    {{ (row.readable_license_label) ? row.readable_license_label : '' }}
                </template>
            </el-table-column>
            <el-table-column v-if="comparison && filteredLicenses[0].termDuration" prop="total_number_of_licenses"
                             label="Zugewiesen / Verfügbar (Vormonat)"
                             min-width="170px">
                <template v-slot="{ row }">
                    {{ (row.total_number_of_licenses_pre_user) ? row.total_number_of_licenses_pre_user : 0 }} /
                    {{ (row.total_number_of_licenses_pre) ? row.total_number_of_licenses_pre : 0 }}
                </template>
            </el-table-column>
            <el-table-column v-if="comparison && !filteredLicenses[0].termDuration" prop="total_number_of_licenses"
                             label="Anzahl (Vormonat)"
                             min-width="170px">
                <template v-slot="{ row }">
                    {{ (row.total_number_of_licenses_pre_user) ? row.total_number_of_licenses_pre_user : 0 }}
                </template>
            </el-table-column>
            <el-table-column v-if="filteredLicenses[0].termDuration" prop="total_number_of_licenses"
                             :label="'Zugewiesen / Verfügbar (' + month + ')'"
                             min-width="200px">
                <template v-slot="{ row }">
                    {{ (row.total_number_of_licenses_user) ? row.total_number_of_licenses_user : 0 }}
                    <span
                        v-if="comparison && parseInt(row.total_number_of_licenses_user) > parseInt(row.total_number_of_licenses_pre_user)"
                        class="text-success"><i
                        class="fad fa-arrow-up"></i> {{
                            parseInt(row.total_number_of_licenses_user) - parseInt(row.total_number_of_licenses_pre_user)
                        }}</span>
                    <span
                        v-if="comparison && parseInt(row.total_number_of_licenses_user) < parseInt(row.total_number_of_licenses_pre_user)"
                        class="text-danger"><i
                        class="fad fa-arrow-down"></i> {{
                            parseInt(row.total_number_of_licenses_pre_user) - parseInt(row.total_number_of_licenses_user)
                        }}</span> / {{ (row.total_number_of_licenses) ? row.total_number_of_licenses : 0 }}
                    <span
                        v-if="comparison && parseInt(row.total_number_of_licenses) > parseInt(row.total_number_of_licenses_pre)"
                        class="text-success"><i
                        class="fad fa-arrow-up"></i> {{
                            parseInt(row.total_number_of_licenses) - parseInt(row.total_number_of_licenses_pre)
                        }}</span>
                    <span
                        v-if="comparison && parseInt(row.total_number_of_licenses) < parseInt(row.total_number_of_licenses_pre)"
                        class="text-danger"><i
                        class="fad fa-arrow-down"></i> {{
                            parseInt(row.total_number_of_licenses_pre) - parseInt(row.total_number_of_licenses)
                        }}</span>
                </template>
            </el-table-column>
            <el-table-column v-if="!filteredLicenses[0].termDuration" prop="total_number_of_licenses"
                             :label="'Anzahl (' + month + ')'"
                             min-width="170px">
                <template v-slot="{ row }">
                    {{ (row.total_number_of_licenses_user) ? row.total_number_of_licenses_user : 0 }}
                    <span
                        v-if="comparison && parseInt(row.total_number_of_licenses_user) > parseInt(row.total_number_of_licenses_pre_user)"
                        class="text-success"><i
                        class="fad fa-arrow-up"></i> {{
                            parseInt(row.total_number_of_licenses_user) - parseInt(row.total_number_of_licenses_pre_user)
                        }}</span>
                    <span
                        v-if="comparison && parseInt(row.total_number_of_licenses_user) < parseInt(row.total_number_of_licenses_pre_user)"
                        class="text-danger"><i
                        class="fad fa-arrow-down"></i> {{
                            parseInt(row.total_number_of_licenses_pre_user) - parseInt(row.total_number_of_licenses_user)
                        }}</span>
                </template>
            </el-table-column>
            <el-table-column v-if="!comparison && filteredLicenses[0].termDuration && filteredLicenses[0].termDuration !== ''"
                             prop="numberYearly" label="Lizenzenlaufzeit Jährlich" min-width="170px">
                <template v-slot="{ row }">
                    {{ (row.numberYearly) ? row.numberYearly : '0' }}
                </template>
            </el-table-column>
            <el-table-column v-if="!comparison && filteredLicenses[0].termDuration && filteredLicenses[0].termDuration !== ''"
                             prop="endDateYearly" label="Ablaufdatum" min-width="120px">
                <template v-slot="{ row }">
                    {{ (row.endDateYearly) ? convertDate(row.endDateYearly) : '-' }}
                </template>
            </el-table-column>
            <el-table-column v-if="!comparison && filteredLicenses[0].termDuration && filteredLicenses[0].termDuration !== ''"
                             prop="numberMonthly" label="Lizenzenlaufzeit Monatlich" min-width="170px">
                <template v-slot="{ row }">
                    {{ (row.numberMonthly) ? row.numberMonthly : '0' }}
                </template>
            </el-table-column>
            <el-table-column v-if="!comparison && filteredLicenses[0].termDuration && filteredLicenses[0].termDuration !== ''"
                             prop="endDateMonthly" label="Ablaufdatum" min-width="120px">
                <template v-slot="{ row }">
                    {{ (row.endDateMonthly) ? convertDate(row.endDateMonthly) : '-' }}
                </template>
            </el-table-column>
            <!--            <el-table-column prop="billingCycle" label="Rechnungszyklus" min-width="170px">
                            <template v-slot="{ row }">
                                {{ getBillingCycle(row) }}
                            </template>
                        </el-table-column>-->
            <!--            <el-table-column prop="unit_price" label="Einkaufspreis" min-width="170px" sortable="custom"
                                         :sort-orders="['ascending', 'descending']">
                            <template v-slot="{ row }">
                                {{
                                    (row.unit_price) ? parseFloat(row.unit_price).toLocaleString('de-CH', {
                                        style: 'currency',
                                        currency: 'CHF'
                                    }) : ''
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="total_price" label="Einkaufspreis (Total)" min-width="170px" sortable="custom"
                                         :sort-orders="['ascending', 'descending']">
                            <template v-slot="{ row }">
                                {{
                                    (row.total_price) ? parseFloat(row.total_price).toLocaleString('de-CH', {
                                        style: 'currency',
                                        currency: 'CHF'
                                    }) : ''
                                }}
                            </template>
                        </el-table-column>-->
        </el-table>
    </div>
</template>
<script>
import moment from 'moment';
import Modal from "@/components/Modal";
import BaseAlert from "@/components/BaseAlert";
import LicenseUsersTable from "@/views/Tables/LicenseUsersTable";
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";

export default {
    name: 'licenses-table',
    components: {
        Modal,
        BaseAlert,
        LicenseUsersTable,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    props: {
        type: {
            type: String
        },
        month: {
            type: String
        },
        comparison: {
            type: Boolean,
            default: false
        },
        licenses: {
            type: Object,
            default: {}
        },
        userLicenses: {
            type: Object,
            default: {}
        },
        title: String
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        filteredLicenses() {
            if (this.searchLicenses === '') {
                return this.licenses;
            } else {
                return this.licenses.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.searchLicenses.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.searchLicenses.toLowerCase()) : ((prop) ? prop.toString(10).toLowerCase().includes(this.searchLicenses.toLowerCase()) : false)))
                });
            }
        },
    },
    methods: {
        getBillingCycle(item) {
            if (item.billingCycle && item.billingCycle === 'monthly') {
                return 'Monatlich';
            }
            if (item.billingCycle && item.billingCycle !== 'monthly') {
                return 'Jährlich';
            }

            return 'Monatlich';
        },
        changeSort(sort) {
            this.currentSort = (!sort.prop) ? '' : sort.prop;
            this.currentSortDir = (!sort.order) ? '' : sort.order;
            this.sortTable();
        },
        sortTable() {
            this.licenses.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === 'descending') modifier = -1;
                if (this.currentSort.includes('price') || this.currentSort.includes('total')) {
                    if (parseFloat(a[this.currentSort]) < parseFloat(b[this.currentSort])) return -1 * modifier;
                    if (parseFloat(a[this.currentSort]) > parseFloat(b[this.currentSort])) return modifier;
                }
                if (this.currentSort.toLowerCase().includes('date')) {
                    if (a[this.currentSort].split('.').reverse().join('') < b[this.currentSort].split('.').reverse().join('')) return -1 * modifier;
                    if (a[this.currentSort].split('.').reverse().join('') > b[this.currentSort].split('.').reverse().join('')) return modifier;
                }
                if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
                if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return modifier;
                return 0;
            });
        },
        convertDate(date) {
            return moment(date).format('DD.MM.YYYY');
        },
        getLicenseUser(data) {
            this.userLicensesData = [];
            this.userLicenses.forEach(entry => {
                if (data.software_license_id === entry.software_license_id || data.own_software_label === entry.readable_label) {
                    this.userLicensesData.push({'object_label': entry.object_label.split("|").pop()});
                }
            });
            this.userModal = true;
        },

    },
    watch: {
        userModal() {
            if (!this.userModal) {
                this.searchUser = '';
            }
        }
    },
    created() {
        this.sortTable();
    },
    data() {
        return {
            userLicensesData: [],
            currentSort: 'part_number',
            currentSortDir: 'ascending',
            searchLicenses: '',
            searchUser: '',
            disabled: true,
            error: '',
            newRequest: '',
            errorText: '',
            userModal: false
        }
    }
}
</script>
<style scoped lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.noPadding {
    padding-right: 0 !important;
}

.errorText {
    color: #f5365c;
}

thead th {
    cursor: pointer;
}

.exportCSV {
    line-height: 0.5;
    height: 36px;
}
</style>
